define('modules/editor/behaviours/has_alignment_guides',['require','exports','module','backbone','../models/editorstate','../views/controls/alignbars'],function(require, exports, module) {
  "use strict";

  var Collection = require("backbone").Collection,
      EditorState = require("../models/editorstate"),
      GroupState = EditorState.groupState,
      MoveState = EditorState.moveState,
      AlignmentBarsView = require("../views/controls/alignbars");
    
  module.exports = {
    _checkAlignment: function(model, position) {
      var points = [];
      if (position) {
        points = GroupState.elements.reduce(function(points, item){
          return _.union(points, item.get("view").getAlignment());
        }, []);
      }
      this.alignmentBars.collection.reset(points);
    },
    _renderBars: function(){
      this._removeBars();
      this._showBars();      
    },
    _showBars: function(){
      var bars = this.alignmentBars.$el.html();
      this.$el.prepend(bars);
    },
    _removeBars: function() {
      this.$el.children().remove(".align-guide");
    },
    mixed: function(klass, proto) {
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this.listenTo(MoveState, "change:movingLastPos", this._checkAlignment);
        this.alignmentBars = new AlignmentBarsView();
        this.alignmentBars.onRender = _.bind(this._renderBars, this);
        this.alignmentBars.render();
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

